import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        VList,
        _vm._l(_vm.contactsList, function (contact, i) {
          return _c(
            VListItem,
            {
              key: i,
              staticClass: "primary--text px-4",
              attrs: {
                href: contact.base_link,
                target: "_blank",
                rel: "noopener noreferrer",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _setup.handleClickContact(contact)
                },
              },
            },
            [
              _c(
                VListItemIcon,
                { staticClass: "mr-4" },
                [
                  _setup.isVisibleContactIcon(contact)
                    ? _c(VIcon, { staticClass: "primary--text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.contactMapIcons[contact.translit]) +
                            "\n        "
                        ),
                      ])
                    : _c(VImg, {
                        attrs: {
                          src: _setup.contactMapIcons[contact.translit],
                          alt: contact.name,
                          width: "24",
                          height: "24",
                        },
                      }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                VListItemContent,
                { staticClass: "text-body-1 text--text" },
                [
                  _c("div", { staticClass: "text-truncate" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_setup.getContactName(contact)) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _setup.isVisibleArrow(contact)
                ? _c(
                    VListItemIcon,
                    [
                      _c(VIcon, { staticClass: "icon-secondary--text" }, [
                        _vm._v("\n          ui-icon-arrow-right\n        "),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }